// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimValueDetails from '@deere/cps-it.warranty-model-factory/lib/claim-value-details';
import ClaimValueSummaryItem from './claim-value-summary-item';
import {buildCurrency} from '../../../../shared/services/build-number';

const ClaimValueSummaryBody = props =>
    <ul className='claim-value-summary-list'>
        <ClaimValueSummaryItem
            amount={buildCurrency(props.claimValueDetails.partsTotal)}
            currency={props.claimValueDetails.currency}
            label='PARTS'
        />
        <ClaimValueSummaryItem
            amount={buildCurrency(props.claimValueDetails.laborTotal)}
            currency={props.claimValueDetails.currency}
            label='LABOR'
        />
        <ClaimValueSummaryItem
            amount={buildCurrency(props.claimValueDetails.otherCreditTotal)}
            currency={props.claimValueDetails.currency}
            label='OTHER'
        />
        <ClaimValueSummaryItem
            amount={buildCurrency(props.claimValueDetails.deductible)}
            currency={props.claimValueDetails.currency}
            label='DEDUCTIBLE'
        />
        <ClaimValueSummaryItem
            amount={buildCurrency(props.claimValueDetails.tax)}
            currency={props.claimValueDetails.currency}
            label='TAX'
        />
    </ul>;

ClaimValueSummaryBody.displayName = 'ClaimValueSummaryBody';
ClaimValueSummaryBody.propTypes = {
    claimValueDetails: PropTypes.instanceOf(ClaimValueDetails).isRequired
};

export default ClaimValueSummaryBody;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-value-summary/claim-value-summary.js